import { defaultAdUnit, IAdUnit } from "../unit";

export enum SpecialEnum {
  DesktopSpecial="Desktop Special",
  MobileSpecial="Mobile Special",
}

type SpecialEnumT = typeof SpecialEnum;

export const SpecialUnits: {[name in SpecialEnumT[keyof SpecialEnumT]]: IAdUnit} = {
  [SpecialEnum.DesktopSpecial]: {
    ...defaultAdUnit,
    sid: "1231805",
    style: {
      width: "100%",
      height: "114px",
      maxWidth: "1880px",
      padding: "0 16px",
      margin: "16px auto 9 auto"
    }
  },
  [SpecialEnum.MobileSpecial]: {
    ...defaultAdUnit,
    sid: "1231806",
    style: {
      width: "100%",
      maxWidth: "600px",
      height: "calc((100vw - 32px) / 2)",
      maxHeight: "300px",
      padding: "0 16px"
    }
  },
};
